module.exports = __webpack_public_path__ + "Flag-292.20776d3bb1272b82ca2c9271e5a224d1.svg";